import React from 'react'

function Cred() {
  return (
    <>
      <div className='w-full bg-gray-300 py-8 px-4'>
        <div className='max-w-[1240px] mx-auto text-center'>
          <h2 className='text-left font-semibold mx-auto py-1'> <i>Сайт kayrakkum.com основан в 2004 году Евгением Борочиным в память о родителях - Тамаре Бушуевой и Якове Борочине</i> </h2>
        </div>
      </div>
    </>
  )
}

export default Cred